import {
  FanpageModel,
  GetFanpageParams,
  GetGroupParams,
  GroupModel
} from '@app/lib/api/fanpage/api.fanpage.models';
import {
  ApprovalRequestsBody,
  ApprovalRequestsOTABody,
  CensorManagement,
  ReviewListBody
} from '@app/lib/api/post/api.post.model';
import {
  OverviewData,
  ReporterItem,
  ReporterSystemRequest
} from '@app/lib/api/report/api.report.models';
import { Post } from '@app/shared/models/post';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ApprovalRequestsActions = createActionGroup({
  source: 'ApprovalRequests',
  events: {
    // Approval List
    'On Get Approval Requests List': props<ApprovalRequestsBody>(),
    'On Get Approval Appeal List': props<ApprovalRequestsBody>(),
    'On Get Approval Requests OTA List': props<ApprovalRequestsOTABody>(),
    'On Get Approval Requests OTA List By Type': props<ApprovalRequestsBody>(),
    'On Get More Approval Requests List': props<ApprovalRequestsBody>(),
    'On Get More Approval Appeal List': props<ApprovalRequestsBody>(),
    'On Get More Approval Requests OTA List': props<ApprovalRequestsOTABody>(),
    'On Get More Approval Requests OTA List By Type': props<ApprovalRequestsBody>(),
    'On Loading Approval Requests List': emptyProps(),
    'On Loading Approval Appeal List': emptyProps(),

    // Selected Items
    'On Select Report Item Approval': props<{
      item: any;
      reportId: string;
    }>(),
    'On Select Report Item Appeal': props<{
      item: any;
      reportId: string;
    }>(),
    'On Select Report Item Approval OTA By Type': props<{
      item: any;
      reportId: string;
    }>(),

    // Overview / History
    'On Get Overview Report Item': props<{ object_id: string }>(),
    'On Get Approval History Report Item': props<{
      data: ReporterSystemRequest;
      isLoadMore: boolean;
      isOta?: boolean;
    }>(),
    'On Get Approval Appeal History Report Item': props<{
      data: ReporterSystemRequest;
      isLoadMore: boolean;
    }>(),
    'On Get Approval History Report Item Verification': props<{
      data: ReporterSystemRequest;
      isLoadMore: boolean;
    }>(),

    // Review List
    'On Get Review List': props<ReviewListBody>(),
    'On Get More Review List': props<ReviewListBody>(),
    'On Select Report Item Review': props<{
      post: any;
      reportId: string;
    }>(),
    'On Select Report Item Appeal Review': props<{
      post: any;
      reportId: string;
    }>(),

    // Censorship
    'On Get Censor Management': props<CensorManagement>(),
    'On Get More Censor Management': props<CensorManagement>(),

    // Verification Request
    'On Get Verification Request': emptyProps(),

    // Reporter
    'On Get Reporter List': props<{ data: ReporterSystemRequest; isLoadMore: boolean }>(),

    // Category
    'On Get Category': emptyProps(),
    'On Select Category': props<{ categories: { type: string; key: string }[] }>(),
    'On Remove Category': props<{ category: { type: string; key: string } }>(),

    // Module
    'On Select Module': props<{
      module: {
        moduleName: string;
        objectType: string;
        role: string;
      };
    }>(),

    'On Select Appeal Module': props<{
      moduleAppeal: {
        moduleName: string;
        objectType: string;
        role: string;
      };
    }>(),

    'On Select Module OTA': props<{
      moduleOTA: {
        moduleName: string;
        objectType: string;
      };
    }>(),

    // Livestream
    'On Update Live Stream List': props<{ list: any }>(),

    // Fanpage / Group
    'On Get User Fanpage': props<{ params: GetFanpageParams }>(),
    'On Get User Group': props<{ params: GetGroupParams }>(),

    // Common
    'On Loading Report Item': emptyProps(),
    'On Loading Report Item OTA By Type': emptyProps(),
    'On Loading Report Item Appeal': emptyProps(),
    'On Update List': props<{ body: any; isReviewList: boolean }>(),
    'On Update Appeal List': props<{ body: any; isReviewList: boolean }>(),
    'On Update List OTA': props<{
      body: any;
      requestInfo: { action: string; objectType: string };
    }>()
  }
});

export const ApprovalRequestsApiActions = createActionGroup({
  source: 'ApprovalRequests Api',
  events: {
    // Approval List
    'On Load Approval Requests Posts Success': props<{
      data: any;
      isOTA?: boolean;
      isSocial?: boolean;
    }>(),
    'On Load Approval Appeal Posts Success': props<{
      data: any;
    }>(),
    'On Load Approval Requests OTA List By Type Success': props<{ data: any }>(),
    'On Load More Approval Requests OTA List By Type Success': props<{
      data: any;
      pageNum: number;
    }>(),
    'On Load More Approval Requests Posts Success': props<{
      data: any;
      isOTA?: boolean;
      pageNum?: number;
    }>(),
    'On Load More Approval Appeal Posts Success': props<{
      data: any;
      pageNum?: number;
    }>(),

    'On Load Approval Requests Posts Fail': props<{ message: string }>(),
    'On Load Approval Appeal Posts Fail': props<{ message: string }>(),
    // Review List
    'On Load Review List Posts Success': props<{ data: any; moduleType: string }>(),
    'On Load Appeal Review List Success': props<{ data: any; moduleType: string }>(),
    'On Load More Review List Posts Success': props<{ data: any }>(),
    'On Load Review List Posts Fail': props<{ message: string }>(),
    'On Load Review List Censor Management Success': props<{ data: any }>(),
    'On Load Review List Censor Management Fail': props<{ message: string }>(),
    'On Load More Review List Censor Management Success': props<{ data: any }>(),
    // User profile
    'On Load Approval Requests User Profile Success': props<{ data: any }>(),
    // Comment
    'On Load Approval Requests Comment Success': props<{ data: any }>(),

    'On Load Select Report Item Success': props<{ post: Post; reportId: string }>(),
    'On Load Select Report Item  Fail': props<{ message: string }>(),
    'On Reset Data Censored': emptyProps(),

    'On Update Approval Requests Post Success': props<{ isError: boolean }>(),
    'On Update Approval Requests Post Fail': emptyProps(),

    'On Update Approval Appeal Post Success': props<{ isError: boolean }>(),
    'On Update Approval Appeal Post Fail': emptyProps(),

    'On Update Approval Requests OTA Success': props<{ requestBody: any; isError: boolean }>(),
    'On Update Approval Requests OTA Fail': emptyProps(),

    'On Update Review Requests Post Success': emptyProps(),
    'On Update Review Requests Post Fail': emptyProps(),

    'On Load Comments Success': props<{ data: any }>(),
    'On Load Comments Fail': props<{ message: string }>(),

    'On Load Verification Request Success': props<{ data: any }>(),
    'On Load Verification Request Fail': props<{ message: string }>(),

    'On Load Fanpage Success': props<{ data: any }>(),
    'On Load Fanpage Fail': props<{ message: string }>(),

    'On Load Group Success': props<{ data: any }>(),
    'On Load Group Fail': props<{ message: string }>(),

    // loading for iframe
    'On Set Loading For Iframe': props<{ isIframeContentLoading: boolean }>(),

    // Reporter list
    'On Load Reporter List Success': props<{ reporterList: ReporterItem[]; isLoadMore: boolean }>(),
    'On Load Reporter List Fail': props<{ message: string }>(),
    'On Reset Data Reporter List': emptyProps(),

    'On Delete Item Auto Labeling': props<{ index: number }>(),
    'On Delete Item Violation Labels': props<{ index: number }>(),

    'On Reset Data Approval Requests': emptyProps(),

    // Overview Data
    'On Get Overview Report Item Success': props<{ data: OverviewData }>(),
    'On Get Overview Report Item Fail': props<{ message: string }>(),

    'On Set Status Show Images': props<{ isShowImages: boolean }>(),

    // Categories
    'On Get Categories Success': props<{ data: { type: string; key: string }[] }>(),
    'On Get Categories Fail': props<{ message: string }>(),

    // Approval History
    'On Get Approval History Report Item Success': props<{
      historyList: any[];
      isLoadMore: boolean;
    }>(),
    'On Get Approval History Report Item Fail': props<{ message: string }>(),
    'On Reset Approval History Reporter List': emptyProps(),

    // Approval Appeal History
    'On Get Approval Appeal History Report Item Success': props<{
      historyList: any[];
      isLoadMore: boolean;
    }>(),
    'On Get Approval Appeal History Report Item Fail': props<{ message: string }>(),
    'On Reset Approval Appeal History Reporter List': emptyProps(),

    // Modules actions
    'On Reset Role With Module': emptyProps(),

    'On Get User Fanpage Success': props<{ userFanpageData: FanpageModel[] }>(),
    'On Get User Group Success': props<{ userGroupData: GroupModel[] }>()
  }
});
